const AssetGlyph = ({ symbol, name, accent, testid }) => (
  <div className="sc-glass rounded-2xl p-5 flex items-center gap-4 flex-1 min-w-[200px]" data-testid={testid}>
    <div
      className="w-11 h-11 rounded-xl flex items-center justify-center font-display font-bold text-sm border"
      style={{
        background: 'linear-gradient(180deg, rgba(255,182,18,0.12), rgba(255,182,18,0.02))',
        borderColor: 'rgba(255, 182, 18, 0.32)',
        color: '#FFE08A',
      }}
    >
      {symbol}
    </div>
    <div className="flex-1">
      <div className="text-[15px] font-semibold leading-tight">{name}</div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)] mt-1">{accent}</div>
    </div>
    <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-[#FFC20E]">
      <span className="w-1.5 h-1.5 rounded-full bg-[#FFB612] animate-pulse" />
      Active
    </div>
  </div>
);

const AssetStrip = () => {
  return (
    <section id="assets" className="relative max-w-7xl mx-auto px-5 md:px-8 pb-4 md:pb-6" data-testid="asset-strip">
      <div className="flex items-center justify-between mb-4">
        <span className="text-[11px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)]">Supported Assets · Strictly Decentralized</span>
        <span className="hidden sm:inline text-[11px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)]">No custodial routing</span>
      </div>
      <div className="flex flex-col md:flex-row gap-3">
        <AssetGlyph symbol="LTC" name="Litecoin" accent="Layer · L1" testid="asset-ltc" />
        <AssetGlyph symbol="TRX" name="TRON" accent="Layer · TRC" testid="asset-trx" />
        <AssetGlyph symbol="DOGE" name="Dogecoin" accent="Layer · L1" testid="asset-doge" />
      </div>
    </section>
  );
};

export default AssetStrip;
